'use strict';
var _interopRequireWildcard = require('@babel/runtime/helpers/interopRequireWildcard');
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');
Object.defineProperty(exports, '__esModule', {
    value: true
});
var _exportNames = {
};
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'));
var _objectWithoutProperties2 = _interopRequireDefault(require('@babel/runtime/helpers/objectWithoutProperties'));
var _react = _interopRequireWildcard(require('react'));
var _gemsShared = require('@tencent/gems-shared');
var _gemsRendererCore = require('@tencent/gems-renderer-core');
var DomainContext = require('../components/OldRender/hooks/useDomainContext').DomainContext;
Object.keys(_gemsRendererCore).forEach(function(key) {
    if (key === 'default' || key === '__esModule') return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _gemsRendererCore[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _gemsRendererCore[key];
        }
    });
});
var _AppRender = require('./AppRender');
var _store = require('./store');
var _OptionContext = require('./OptionContext');
var _IteratorContext = require('./IteratorContext');
Object.keys(_IteratorContext).forEach(function(key) {
    if (key === 'default' || key === '__esModule') return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _IteratorContext[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _IteratorContext[key];
        }
    });
});
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    var _arguments = arguments, _loop = function(i) {
        var source = _arguments[i] != null ? _arguments[i] : {
        };
        if (i % 2) {
            ownKeys(Object(source), true).forEach(function(key) {
                (0, _defineProperty2.default)(target, key, source[key]);
            });
        } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
            ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
    };
    for(var i = 1; i < arguments.length; i++)_loop(i);
    return target;
}
// For debug
// window.stores = [];
var RenderApp = function() {
    var _useContext = (0, _react.useContext)(_OptionContext.OptionContext), schema = _useContext.schema, renderInstance = _useContext.renderInstance, materials = _useContext.materials, autoParseStyle = _useContext.autoParseStyle;
    var renderStore = (0, _store.useRenderStore)(); // For debug
    // (0, _react.useEffect)(() => {
    //   window.stores.push(renderStore);
    //   return () => {
    //     window.stores = window.stores.filter(store => store !== renderStore) || [];
    //   };
    // }, [renderStore]);
    var schemaInstance = (0, _react.useMemo)(function() {
        if (schema) {
            return (0, _gemsRendererCore.parseSchema)(schema, materials, {
                autoParseStyle: autoParseStyle,
                renderStore: renderStore
            });
        }
        return {
            componentInstances: [],
            pluginInstances: []
        };
    }, [
        schema,
        materials,
        autoParseStyle,
        renderStore
    ]);
    (0, _react.useEffect)(function() {
        return function() {
            (0, _gemsShared.clearHocMap)();
        };
    }, []);
    var _ref = renderInstance !== null && renderInstance !== void 0 ? renderInstance : schemaInstance, componentInstances = _ref.componentInstances, pluginInstances = _ref.pluginInstances;
    (0, _gemsShared.initComponentInstanceIndexMap)(componentInstances);
    return(/*#__PURE__*/ _react.default.createElement(_AppRender.AppRender, {
        pluginInstances: pluginInstances,
        componentInstances: componentInstances
    }));
};
var Renderer = function(_ref2) {
    var _ref2$rendererHooks = _ref2.rendererHooks, rendererHooks = _ref2$rendererHooks === void 0 ? {
    } : _ref2$rendererHooks, externalStore = _ref2.externalStore, _ref2$meta = _ref2.meta, meta = _ref2$meta === void 0 ? {
    } : _ref2$meta, _ref2$global = _ref2.global, global = _ref2$global === void 0 ? {
    } : _ref2$global, _ref2$autoParseStyle = _ref2.autoParseStyle, autoParseStyle = _ref2$autoParseStyle === void 0 ? true : _ref2$autoParseStyle, _ref2$parseExpression = _ref2.parseExpression, parseExpression = _ref2$parseExpression === void 0 ? true : _ref2$parseExpression, restProps = (0, _objectWithoutProperties2.default)(_ref2, [
        'rendererHooks',
        'externalStore',
        'meta',
        'global',
        'autoParseStyle',
        'parseExpression', 
    ]);
    var constructHook = rendererHooks.construct, didMountHook = rendererHooks.didMount;
    (0, _react.useState)(function() {
        constructHook === null || constructHook === void 0 ? void 0 : constructHook();
    });
    (0, _react.useEffect)(function() {
        didMountHook === null || didMountHook === void 0 ? void 0 : didMountHook();
    }, []);
    var domainContextValue = (0, _react.useContext)(DomainContext);
    return(/*#__PURE__*/ _react.default.createElement(_store.RenderStoreProvider, {
        renderStore: externalStore
    }, /*#__PURE__*/ _react.default.createElement(_OptionContext.OptionContext.Provider, {
        value: _objectSpread({
            meta: meta,
            global: global,
            autoParseStyle: autoParseStyle,
            parseExpression: parseExpression,
            domains: domainContextValue
        }, restProps)
    }, /*#__PURE__*/ _react.default.createElement(RenderApp, null))));
};
var _default = Renderer;
exports.default = _default;
